var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendmomentsLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 152.523,
    height: 20.166,
    viewBox: "0 0 152.523 20.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_23189",
    "data-name": "Rechteck 23189",
    width: 152.523,
    height: 20.166,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_19853",
    "data-name": "Gruppe 19853",
    transform: "translate(-1 6.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_17540",
    "data-name": "Gruppe 17540",
    transform: "translate(1 -6.49)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282853",
    "data-name": "Pfad 282853",
    d: "M3.119,15.646a4.88,4.88,0,0,1,2.171-.472,5.267,5.267,0,0,1,3.819,1.573l-.209.21a4.594,4.594,0,0,0-3.505-1.521c-2.825-.079-4.682,3.3-1.073,4.747a33,33,0,0,1,3.924,1.651,3.664,3.664,0,0,1,.1,6.317,5.642,5.642,0,0,1-2.668.629A6.51,6.51,0,0,1,1,26.869l.262-.21A5.824,5.824,0,0,0,5.29,28.466c3.5.184,4.551-2.937,3.165-4.458-1.282-1.364-3.819-1.889-5.388-2.649a3.2,3.2,0,0,1,.052-5.717",
    transform: "translate(-1 -8.617)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282854",
    "data-name": "Pfad 282854",
    d: "M28.817,14.84c2.772,0,5.519,1.835,5.493,5.113h-9.7A5.709,5.709,0,0,0,24.45,21.6c.026,4.2,2.642,6.373,5.311,6.373a5.159,5.159,0,0,0,3.948-1.915L34,26.3a6.27,6.27,0,0,1-4.862,2.233c-3.139,0-6.251-2.256-6.33-6.9-.026-3.671,2.225-6.792,6.016-6.792m3.845,4.72c1.255,0,1.2-.734.785-1.626a4.47,4.47,0,0,0-4.082-2.6c-2.458,0-4.109,1.965-4.684,4.221Z",
    transform: "translate(-12.341 -8.444)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282855",
    "data-name": "Pfad 282855",
    d: "M49.668,15.206h2.537v1.7a5.057,5.057,0,0,1,4.29-2.124c2.354,0,4.629,1.39,4.629,4.038v9.362H59.607V18.825c.053-2.623-1.6-3.671-3.347-3.671-1.962,0-4.054,1.285-4.054,3.069v9.965H50.715V15.862l-1.047-.419Z",
    transform: "translate(-26.315 -8.415)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282856",
    "data-name": "Pfad 282856",
    d: "M80.22,9.119a6.142,6.142,0,0,1,3.426-1.077,5.664,5.664,0,0,1,4.027,1.7V2.166L86.6,1.721V1.51h2.564V21.284h-.392l-.993-1.938a5.1,5.1,0,0,1-4.394,2.176,5.6,5.6,0,0,1-3.244-.97c-3.531-2.44-3.451-9.021.079-11.434M81.135,20a3.941,3.941,0,0,0,2.72,1.077,4.625,4.625,0,0,0,3.819-2.153v-8.5a4.614,4.614,0,0,0-3.767-1.938,3.918,3.918,0,0,0-3.086,1.443c-2.093,2.517-2.093,7.762.314,10.07",
    transform: "translate(-40.809 -1.51)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282857",
    "data-name": "Pfad 282857",
    d: "M106.4,15.438V15.2h2.563v1.679a5.051,5.051,0,0,1,4.263-2.1,4.532,4.532,0,0,1,4.341,2.57,4.971,4.971,0,0,1,4.552-2.57c2.354,0,4.628,1.39,4.628,4.038h.027v9.362h-1.517V18.821h-.026c.052-2.6-1.569-3.619-3.322-3.619-1.938,0-4.054,1.285-4.106,3.042a3.974,3.974,0,0,1,.052.574v9.365h-1.491V18.821c.052-2.623-1.6-3.671-3.348-3.671-1.961,0-4.054,1.285-4.054,3.069v9.965h-1.517V15.858Z",
    transform: "translate(-55.828 -8.41)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282858",
    "data-name": "Pfad 282858",
    d: "M158.672,28.616c-8.111,0-8.111-13.663,0-13.663,8.135,0,8.135,13.663,0,13.663m0-13.322c-6.12,0-6.12,12.955,0,12.955s6.12-12.955,0-12.955",
    transform: "translate(-79.851 -8.503)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282859",
    "data-name": "Pfad 282859",
    d: "M181.233,15.438V15.2H183.8v1.679a5.051,5.051,0,0,1,4.263-2.1,4.532,4.532,0,0,1,4.341,2.57,4.971,4.971,0,0,1,4.552-2.57c2.354,0,4.628,1.39,4.628,4.038h.027v9.362h-1.517V18.821h-.026c.052-2.6-1.569-3.619-3.322-3.619-1.938,0-4.054,1.285-4.106,3.042a3.974,3.974,0,0,1,.052.574v9.365H191.2V18.821c.052-2.623-1.6-3.671-3.348-3.671-1.961,0-4.054,1.285-4.054,3.069v9.965h-1.516V15.858Z",
    transform: "translate(-94.751 -8.41)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282860",
    "data-name": "Pfad 282860",
    d: "M233.466,14.84c2.772,0,5.519,1.835,5.492,5.114h-9.7A5.708,5.708,0,0,0,229.1,21.6c.026,4.2,2.642,6.373,5.312,6.373a5.161,5.161,0,0,0,3.948-1.914l.287.236a6.269,6.269,0,0,1-4.864,2.229c-3.139,0-6.251-2.256-6.33-6.9-.026-3.671,2.225-6.792,6.016-6.792m3.845,4.72c1.255,0,1.2-.734.785-1.626a4.471,4.471,0,0,0-4.078-2.592c-2.459,0-4.106,1.967-4.682,4.222Z",
    transform: "translate(-118.792 -8.444)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282861",
    "data-name": "Pfad 282861",
    d: "M254.318,15.206h2.537v1.7a5.057,5.057,0,0,1,4.29-2.124c2.354,0,4.629,1.39,4.629,4.038v9.362h-1.518V18.825c.053-2.623-1.6-3.671-3.347-3.671-1.962,0-4.054,1.285-4.054,3.069v9.965h-1.491V15.862l-1.047-.419Z",
    transform: "translate(-132.767 -8.415)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282862",
    "data-name": "Pfad 282862",
    d: "M282.17,8.3h1.857V2.166l-1.046-.446v-.21h2.563V8.3h3.5V8.7h-3.5v9.755a2.8,2.8,0,0,0,.759,2.334,2,2,0,0,0,1.334.446,4.491,4.491,0,0,0,2.329-.789l.209.262a5.715,5.715,0,0,1-2.877.917c-2.2,0-3.27-1.415-3.27-3.589V8.7H282.17Z",
    transform: "translate(-147.255 -1.511)",
    fill: "#010811"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_282863",
    "data-name": "Pfad 282863",
    d: "M302.007,15.646a4.88,4.88,0,0,1,2.171-.472A5.267,5.267,0,0,1,308,16.747l-.209.21a4.594,4.594,0,0,0-3.505-1.521c-2.825-.079-4.682,3.3-1.072,4.747a32.994,32.994,0,0,1,3.923,1.651,3.664,3.664,0,0,1,.1,6.317,5.642,5.642,0,0,1-2.668.629,6.509,6.509,0,0,1-4.681-1.914l.261-.21a5.822,5.822,0,0,0,4.028,1.809c3.5.184,4.551-2.937,3.165-4.458-1.281-1.364-3.819-1.888-5.388-2.648a3.2,3.2,0,0,1,.052-5.717",
    transform: "translate(-156.472 -8.617)",
    fill: "#010811"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendmomentsLogo);
export default __webpack_public_path__ + "static/media/sendmoments_logo.bfb26688bf41c0fe7eb8bb64e61b711e.svg";
export { ForwardRef as ReactComponent };